module.exports = __webpack_public_path__ + "img/badge.14d36b0.jpg";